module.exports = __webpack_public_path__ + "media/images/equipments-bg-01-f62d5a172fefad53e4df5e0013675467.svg";